module.exports = ".imgLen{\r\n    width: 126px;\r\n}\r\n\r\n.divLenImg{\r\n    float: left;\r\n    margin-right: 10px;\r\n}\r\n\r\n.divLenImg:hover{\r\n    cursor: pointer;\r\n}\r\n\r\n.divIdiomasPage{\r\n    width: 100%;\r\n}\r\n\r\n#google_translate_element{\r\n    height: 20px;\r\n}\r\n\r\n.aviso{\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    padding: 5px;\r\n    background-color: rgb(100, 208, 241);\r\n    border-radius: 5px;\r\n    font-weight: bold;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/idiomas/idiomas.component.css
// module id = ./src/app/idiomas/idiomas.component.css
// module chunks = main